import * as z from "zod";
import { ReturnInstructionTranslationSetSchema } from "./return-instruction-translation-sets";

/** The team's custom return instructions, each with its stored translations. */
export const getReturnInstructionTranslations = {
  name: "getReturnInstructionTranslations" as const,
  input: z.null(),
  output: z.object({ sets: z.array(ReturnInstructionTranslationSetSchema) }),
};
